require('./RAAccountDetailsView.scss');

//@venders
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @components
const {
    BrokerInvestmentSpecialist,
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const RARoboMoreOptionsButton = require('../../components/RARoboMoreOptionsButton/RARoboMoreOptionsButton');
const RACgdNumber = require('../../components/RACgdNumber/RACgdNumber');
const RAStrategyHistoryModal = require('../../components/RAStrategyHistoryModal/RAStrategyHistoryModal');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @actions
const raAccountDetailsActions = require('../../actions/RAAccountDetails');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');

// @constants
const {
    GOAL_TRACKING_URL,
    MYPROFILE_BROKER_ROBO_URL,
    RA_LAST_MOVEMENTS_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACKING_URL,
    PORTFOLIO_TRACK_URL_PARA,
    RA_CANCEL_PLAN_URL,
    RA_MODIFY_PLAN_URL,
    RA_MANAGEMENT_CONTRIBUTION_URL,
    RA_REIMBURSEMENT_URL,
    SUITABILITY_TEST_STATUS_URL,
} = require('../../raConstants/index');

//@commons
const RACover = require('../../components/commons/RACover/RACover');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { Portfolios } = require('../../utilities/RAPortfolioHelper');

// @actions
const { MYPROFILE_BROKER_URL } = require('constants/index');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');

const headerIcons = {
    1: 'icon-KualaLumpur-small',
    2: 'icon-shangai-small',
    3: 'icon-taipei-small', // @TODO: test it when ezequiel upload icon-fonts
    4: 'icon-NewYork-small',
    5: 'icon-dubai-small',
};

class RAAccountDetailsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
        this.handleOnLinkClick = this.handleOnLinkClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        const {
            immGlobalPosition,
            match: {params: { portfolioId } },
        } = this.props;
        const portfolioInfo = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);

        if (!portfolioInfo) {
            this.props.fetchMyInvestments();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immGlobalPosition,
            match: { params: { portfolioId } },
        } = this.props;
        const immGlobalPositionPrev = prevProps.immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const portfolioInfo = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);

        if (immGlobalPositionPrev !== portfolioInfo && !portfolioInfo) {
            this.props.fetchMyInvestments();
        }
    }

    getBreadcrumb() {
        const {
            immGlobalPosition,
            match: { params: { objective } },
        } = this.props;

        const origin = immGlobalPosition.get('originRedirection');
        let parentTitle;
        let parentUrl;
        if (origin === PORTFOLIO_TRACK_URL_PARA) {
            parentTitle = formatText(
                'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
            );
            parentUrl = `${PORTFOLIO_TRACKING_URL}/${immGlobalPosition.get(
                'idRedirection',
            )}`;
        } else if (origin === OBJECTIVE_TRACK_URL_PARA) {
            parentTitle = formatText('breadcrumb-breadcrumb_objectiveTracking');
            parentUrl = `${GOAL_TRACKING_URL}/${immGlobalPosition.get(
                'idRedirection',
            )}`;
        }

        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText(
                    'raAccountDetail-raAccountDetail_investBreadcrumb',
                ),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            ...(origin === PORTFOLIO_TRACK_URL_PARA ||
            origin === OBJECTIVE_TRACK_URL_PARA
                ? [
                      {
                          text: parentTitle,
                          url: parentUrl,
                      },
                  ]
                : []),
            {
                text: objective
                    ? formatText('breadcrumb-breadcrumb_objectiveTracking')
                    : formatText(
                          'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
                      ),
            },
        ];
    }

    handleFeatureModal(link, type) {
        const { history, immRAFeatureFlag } = this.props;
        if (!immRAFeatureFlag.get(type)) {
            this.props.featureModalToggle();
        } else {
            history.push(link);
        }
    }

    getMoreOptions(immPortfolio) {
        const reimbursementLink = `${RA_REIMBURSEMENT_URL}/${this.props.match.params.portfolioId}`;
        const changeProductLink = `${RA_MODIFY_PLAN_URL}/${this.props.match.params.portfolioId}`;
        const cancelServiceLink = `${RA_CANCEL_PLAN_URL}/${this.props.match.params.portfolioId}`;

        return [
            {
                link: `${RA_MANAGEMENT_CONTRIBUTION_URL}/${this.props.match.params.portfolioId}`,
                text: formatText(
                    'raGlobal-raGlobal_moreOptionsManagementContribution',
                ),
                visible:
                    immPortfolio && !!immPortfolio.get('recurringTransfers'),
            },
            {
                handleClick: () => {
                    this.handleFeatureModal(reimbursementLink, 'refund');
                },
                text: formatText('broker-globalPositionRAPopOverRefundRequest'),
                visible: true,
            },
            {
                link: `${RA_LAST_MOVEMENTS_URL}/${OBJECTIVE_TRACK_URL_PARA}/${this.props.match.params.portfolioId}`,
                text: formatText('broker-globalPositionRAPopOverMovements'),
                visible: true,
            },
            {
                handleClick: () => {
                    this.handleFeatureModal(changeProductLink, 'changeProduct');
                },
                text: formatText(
                    'broker-globalPositionRAPopOverModifyStrategy',
                ),
                visible: true,
            },
            {
                link: SUITABILITY_TEST_STATUS_URL,
                text: formatText(
                    'broker-globalPositionRAPopOverSuitabilityTest',
                ),
                visible: true,
            },
            {
                handleClick: () => {
                    this.handleFeatureModal(cancelServiceLink, 'cancelService');
                },
                text: formatText('broker-globalPositionRAPopOverCancelService'),
                visible: true,
            },
        ];
    }

    getTitle() {
        const {
            match: { params: { objective }},
            immAccountDetails,
        } = this.props;
        const objectiveName = immAccountDetails.getIn([
            'objectiveDetails',
            'objectiveName',
        ]);
        const portfolioName = immAccountDetails.getIn([
            'portfolioDetails',
            'portfolioName',
        ]);
        const coverTitleStatement = objective
            ? objectiveName
            : formatText(
                  'raPortfolioDistributionWidget-raPortfolioDistributionWidget_cartera',
                  [portfolioName],
              );
        return coverTitleStatement;
    }

    getObjectiveStrategy(immAccountDetails, objective) {
        let label;
        let strategyName;
        if (!!objective) {
            label = formatText('raAccountDetail-strategyRealtedToObj');
            strategyName = immAccountDetails.getIn([
                'objectiveDetails',
                'portfolioName',
            ]);
        } else {
            const portfolioType = immAccountDetails.getIn([
                'portfolioDetails',
                'portfolioType',
            ]);
            label = formatText(
                'raAccountDetails-raAccountDetails_associatedStrategy',
            );
            strategyName = !!portfolioType
                ? Portfolios[portfolioType].portfolioName
                : '';
        }

        return (
            <div className="row ra-account-details-view__column-margin">
                <div className="col-md-4">
                    <div className="ra-account-details-view__info-title">
                        {label}
                    </div>
                    <div className="ra-account-details-view__info-value">
                        {strategyName}
                    </div>
                    <div className="ra-account-details-view__info-link">
                        <OKLink
                            onClick={this.handleOnLinkClick}
                            modifier="complementary"
                        >
                            <FormattedText value="raAccountDetail-historyModal" />
                        </OKLink>
                    </div>
                </div>
            </div>
        );
    }

    getProductIcon() {
        const { immAccountDetails } = this.props;
        const portfolioProductType = immAccountDetails.getIn([
            'portfolioDetails',
            'portfolioType',
        ]);
        const iconTitleClass = `ra-portfolio-tracking-view__product-icon ${headerIcons[portfolioProductType]}`;
        return <i className={iconTitleClass} />;
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
            />
        );
    }

    handleOnLinkClick() {
        this.setState({
            isModalOpen: true,
        });
    }

    handleCloseModal() {
        this.setState({
            isModalOpen: false,
        });
    }

    buildModal(immPortfolio) {
        const {
            getPortfolioHistory,
            immAccountDetails,
            match: {params: { portfolioId }},
        } = this.props;
        return (
            <RAStrategyHistoryModal
                isModalOpen={this.state.isModalOpen}
                onModalClose={this.handleCloseModal}
                portfolioId={portfolioId}
                immAccountDetails={immAccountDetails}
                getPortfolioHistory={getPortfolioHistory}
                immPortfolio={immPortfolio}
            />
        );
    }

    render() {
        const {
            immAccountDetails,
            immGlobalPosition,
            immProfileFields,
            match: {params: { portfolioId, objective }},
        } = this.props;
        const breadcrumb = this.getBreadcrumb();
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const moreOptionsArray = immPortfolio
            ? this.getMoreOptions(immPortfolio)
            : [];
        let rightContent = (
            <RARoboMoreOptionsButton
                moreOptions={moreOptionsArray}
                shouldGoBack={true}
            />
        );
        const productIcon = objective ? null : this.getProductIcon();
        let accountNumber,
            cgdNumber,
            cgdHolderName = formatText('broker-notAvailableData'),
            subtitle;
        const profileName = immProfileFields.get('fullname');
        if (immAccountDetails) {
            accountNumber = immAccountDetails.get('accountNumber');
            cgdNumber = immAccountDetails.get('cgdNumber');
            cgdHolderName = immAccountDetails.get('cgdHolderName');
            if (cgdNumber) {
                subtitle = <RACgdNumber cgdNumberVal={cgdNumber} />;
            }
        }
        const title = this.getTitle();
        const objectiveStrategy = this.getObjectiveStrategy(
            immAccountDetails,
            objective,
        );
        const featureModal = this.buildFeatureModal();
        const modal = this.state.isModalOpen
            ? this.buildModal(immPortfolio)
            : null;

        const cover = (
            <RACover
                breadcrumb={breadcrumb}
                title={title}
                section="goal"
                showHelp={false}
                onUpdateTitle={this.handleOnUpdateCoverTitle}
                fontSize="34px MarkOT"
                rightContent={rightContent}
                iconTitle={productIcon}
                subtitle={subtitle}
            />
        );
        return (
            <div className="ra-account-details-view grid-view">
                {modal}
                <div className="container-fluid">
                    <div className="row">{cover}</div>
                </div>
                <div className="ra-account-details-view__container">
                    <div className="grid-view__body">
                        <div className="row no-gutters">
                            <div className="col-xs-12 col-md-8">
                                <div className="ra-account-details-view__account-info-div ra-account-details-view__wrapper">
                                    <div className="ra-account-details-view__title">
                                        <FormattedText value="raAccountDetail-accountContractInfo" />
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 ra-account-details-view__column">
                                            <div className="ra-account-details-view__info-title">
                                                <FormattedText value="raAccountDetail-accountNo" />
                                            </div>
                                            <div className="ra-account-details-view__info-value">
                                                {cgdNumber}
                                            </div>
                                        </div>
                                        <div className="col-md-8 ra-account-details-view__column">
                                            <div className="ra-account-details-view__info-title">
                                                <FormattedText value="raAccountDetail-accountType" />
                                            </div>
                                            <div className="ra-account-details-view__info-value">
                                                <FormattedText value="raAccountDetail-discrecionalManagmentAccount" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row ra-account-details-view__column-margin">
                                        <div className="col-md-4">
                                            <div className="ra-account-details-view__info-title">
                                                <FormattedText value="raAccountDetail-participants" />
                                            </div>
                                            <div className="ra-account-details-view__info-value">
                                                <FormattedText value="raAccountDetail-holder" />
                                            </div>
                                            <div className="ra-account-details-view__info-value">
                                                {profileName}
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="ra-account-details-view__info-title">
                                                <FormattedText value="raAccountDetail-associatedAccount" />
                                            </div>
                                            <div className="ra-account-details-view__info-value">
                                                {cgdHolderName}
                                            </div>
                                            <div className="ra-account-details-view__info-value">
                                                {accountNumber}
                                            </div>
                                        </div>
                                    </div>
                                    {objectiveStrategy}
                                    {featureModal}
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <BrokerInvestmentSpecialist modifier="broker" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAAccountDetailsView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    getPortfolioHistory: PropTypes.func.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immAccountDetails: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immAccountDetails: state.raAccountDetails,
        immGlobalPosition: state.raGlobalPosition,
        immProfileFields: state.profile,
        immRAFeatureFlag: state.raFeatureFlag,
    }),
    {
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        getPortfolioHistory: raAccountDetailsActions.getPortfolioHistory,
    },
)(withRouter(RAAccountDetailsView));
